module.exports = {
  title: 'Banner管理',
  route: {
    path: 'content-manage',
    children: {
      path: 'banner-list',
    },
  },
};
